import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import dayjs from "dayjs";
import queryString from "query-string";

import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { formatCurrency } from "../../../utils/helpers";

class PrintDescuentos extends Component {
    state = {
        descuentos: [],
    };
    componentDidMount() {
        this.getDescuentos();
    }
    getDescuentos = async () => {
        const response = await this.props.request(
            "descuentos" + window.location.search
        );

        if (response.data) {
            this.setState({
                descuentos: response.data,
            });
            window.print();
        }
    };
    render() {
        const { descuentos } = this.state;
        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];

        const query = queryString.parse(window.location.search);
        const {estado, desde, hasta} = query;


        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>
                        {estado === 'todos' && 'Todos los '}
                        Descuentos Programados
                        {estado === 'pendiente' && ' Pendientes'}
                        {estado === 'completado' && ' Completados'}
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {new Date().toLocaleString()}
                    </div>
                    <div className='col-md-12 text-center'>
                        Desde: {dayjs(desde).format('DD MMM, YYYY')} - Hasta: {dayjs(hasta).format('DD MMM, YYYY')}
                    </div>
                    <div className='col-md-12 p-b-10'></div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className="float-left text-left">
                            <p><strong># Descuentos:</strong> {descuentos.length}</p>
                            <p><strong>Cuotas Pendientes:</strong> {descuentos.reduce((p, d) => {
                                return p + d.cuotasPendientes.length
                            }, 0)}</p>
                            <p><strong>Cuotas Pagadas:</strong> {descuentos.reduce((p, d) => {
                                return p + d.cuotasCompletadas.length
                            }, 0)}</p>
                        </div>
                        <div className='float-right'>
                            <p><strong>Cantidad Prestado:</strong> {formatCurrency(descuentos.reduce((p, d) => {
                                return p + parseFloat(d.montoTotal);
                            }, 0))}</p>
                            <p><strong>Total Pagado:</strong> {formatCurrency(descuentos.reduce((p, d) => {
                                if (d.cuotasCompletadas) {
                                    return p + d.cuotasCompletadas.reduce((a, c) => a + parseFloat(c.monto), 0);
                                }
                                return p + parseFloat(d.montoTotal)
                            }, 0))}</p>
                            <p><strong>Total Pendiente:</strong> {formatCurrency(descuentos.reduce((p, d) => {
                                if (d.cuotasPendientes) {
                                    return p + d.cuotasPendientes.reduce((a, c) => a + parseFloat(c.monto), 0);
                                }
                                return p + parseFloat(d.montoTotal)
                            }, 0))}</p>
                        </div>
                    </div>
                </div>
                <table className='table'>
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>Empleado</th>
                            <th style={{ width: "35%" }}>Detalle</th>
                            <th>Monto</th>
                            <th>Cuota</th>
                            <th className="text-right">Descuentos</th>
                        </tr>
                    </thead>
                    <tbody>
                        {descuentos.map((descuento) => {
                            return (
                                <tr key={descuento.id}>
                                    <td>
                                        <strong>
                                            { descuento.empleado }
                                        </strong>
                                        {descuento.telefono && <div>
                                            Tel: {descuento.telefono}
                                        </div>}
                                    </td>
                                    <td>
                                        <small>
                                            Frecuencia: {
                                                descuento.frecuencia
                                            }
                                        </small>
                                        <div className="descuento__descripcion">
                                            {
                                                descuento.descripcion
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div><strong>{formatCurrency(descuento.montoTotal)}</strong></div>
                                        # Cuotas: {descuento.cuotas?.length}
                                    </td>
                                    <td>
                                        <div><strong>{formatCurrency(descuento.monto)}</strong></div>
                                        Pendientes: {descuento.cuotasPendientes?.length}
                                    </td>
                                    <td  className="text-right">
                                    {descuento.cuotasCompletadas?.length > 0 && <div>
                                        <strong>Último:{' '}</strong>
                                        <div>
                                            {descuento.cuotasCompletadas.length && dayjs(
                                                descuento.cuotasCompletadas[0].fecha
                                            ).format(
                                                "YYYY-MM-DD"
                                            )}
                                        </div>
                                    </div>}
                                    {descuento.cuotasPendientes?.length > 0 && <div>
                                        <strong>Próximo:{' '}</strong>
                                        <div>
                                            {descuento.cuotasPendientes.length && dayjs(
                                                descuento.cuotasPendientes[0].fecha
                                            ).format(
                                                "YYYY-MM-DD"
                                            )}
                                        </div>
                                    </div>}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(withRequest(PrintDescuentos));
